import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const location = useLocation();
  const token = localStorage.getItem("accessToken");

  if (!token) {
    // 토큰이 없으면 로그인 페이지로 리다이렉트
    const returnTo = `${location.pathname}${location.search || ""}`;
    return <Navigate to="/login" replace state={{ returnTo }} />;
  }

  return children;
};

export default PrivateRoute;
